import React from "react";
import theme from "theme";
import { Theme, Strong, Text, Box, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"faq"} />
		<Helmet>
			<title>
				PizzaFiesta
			</title>
			<meta name={"description"} content={"¡La pizza perfecta está a solo un bocado de distancia!"} />
			<meta property={"og:title"} content={"PizzaFiesta"} />
			<meta property={"og:description"} content={"¡La pizza perfecta está a solo un bocado de distancia!"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/6763d32ce778710018d5bc89/images/Iconarchive-Fat-Sugar-Food-Pizza.1024.png?v=2024-12-19T08:59:35.315Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/6763d32ce778710018d5bc89/images/Iconarchive-Fat-Sugar-Food-Pizza.1024.png?v=2024-12-19T08:59:35.315Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/6763d32ce778710018d5bc89/images/Iconarchive-Fat-Sugar-Food-Pizza.1024.png?v=2024-12-19T08:59:35.315Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/6763d32ce778710018d5bc89/images/Iconarchive-Fat-Sugar-Food-Pizza.1024.png?v=2024-12-19T08:59:35.315Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/6763d32ce778710018d5bc89/images/Iconarchive-Fat-Sugar-Food-Pizza.1024.png?v=2024-12-19T08:59:35.315Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/6763d32ce778710018d5bc89/images/Iconarchive-Fat-Sugar-Food-Pizza.1024.png?v=2024-12-19T08:59:35.315Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/6763d32ce778710018d5bc89/images/Iconarchive-Fat-Sugar-Food-Pizza.1024.png?v=2024-12-19T08:59:35.315Z"} />
			<meta name={"msapplication-TileColor"} content={"#232323"} />
		</Helmet>
		<Components.Header>
			<Override slot="text">
				PizzaFiesta
			</Override>
		</Components.Header>
		<Section padding="100px 0 100px 0" background="--color-darkL2" quarkly-title="FAQ-4">
			<Text margin="0px 0px 3rem 0px" font="normal 600 42px/1.2 --fontFamily-sans" color="--light">
				<Strong>
					Preguntas Frecuentes
				</Strong>
			</Text>
			<Box
				min-width="100px"
				min-height="100px"
				display="grid"
				grid-template-columns="repeat(2, 1fr)"
				grid-gap="50px 50px"
				md-grid-template-columns="1fr"
				sm-grid-gap="35px 0"
			>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Cuánto espacio necesito para abrir una pizzería PizzaFiesta?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Las ubicaciones de nuestras pizzerías generalmente requieren entre 100 a 200 metros cuadrados, pero esto puede variar según la ubicación y las condiciones del mercado. Trabajamos contigo para encontrar el espacio ideal que se ajuste a tus necesidades.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Qué costos recurrentes están involucrados?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Además de la inversión inicial, los franquiciados pagan una cuota mensual de regalías del 7% y una contribución al marketing del 3%.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Puedo ser propietario de múltiples ubicaciones de PizzaFiesta?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						¡Sí! Muchos de nuestros franquiciados exitosos operan varias ubicaciones. Ofrecemos oportunidades para franquicias de múltiples unidades, lo que te permitirá hacer crecer tu negocio y aumentar tu potencial de ingresos.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Qué apoyo ofrece PizzaFiesta a los propietarios de franquicias?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						PizzaFiesta ofrece un apoyo integral, incluyendo formación inicial sobre operaciones, marketing y servicio al cliente, así como orientación operativa continua. Te brindamos coaching empresarial constante para asegurarnos de que tu pizzería funcione de manera eficiente y exitosa.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Puedo abrir una franquicia de PizzaFiesta en cualquier ubicación?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Aunque ofrecemos flexibilidad en la elección de ubicación, tenemos pautas específicas para la selección del sitio, con el fin de garantizar el potencial de mercado y la coherencia de la marca. Te ayudaremos a elegir la mejor ubicación, considerando factores como el tráfico, la población y la competencia.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Qué tipo de desempeño financiero puedo esperar de una franquicia de PizzaFiesta?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						El desempeño financiero varía según la ubicación y las condiciones del mercado. Proporcionamos divulgaciones financieras detalladas para brindarte una mejor comprensión de las ganancias potenciales. Nuestro equipo trabajará contigo para crear un plan de negocios personalizado para tu ubicación de franquicia.
					</Text>
				</Box>
			</Box>
		</Section>
		<Components.Footer3 />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});